import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 147.58 147.58"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { fill: "currentColor" }, [
  /*#__PURE__*/_createElementVNode("path", { d: "m97.65 68.45-1.15 9.2a3.066 3.066 0 0 1-3.04 2.69h-14.9v38.47q-2.355.21-4.77.21c-3.6 0-7.11-.36-10.51-1.04V80.34H51.82c-1.05 0-1.91-.86-1.91-1.92V66.91c0-1.05.86-1.92 1.91-1.92h11.46V47.72c0-10.6 8.55-19.19 19.11-19.19h13.37c1.05 0 1.91.86 1.91 1.92v11.51c0 1.05-.86 1.92-1.91 1.92h-9.55c-4.22 0-7.64 3.44-7.64 7.68v13.43h16.05c1.84 0 3.27 1.62 3.04 3.45h-.01Z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M73.79 147.58c-19.71 0-38.24-7.68-52.18-21.61C7.67 112.03 0 93.5 0 73.79s7.68-38.24 21.61-52.18C35.55 7.67 54.08 0 73.79 0s38.24 7.68 52.18 21.61c13.94 13.94 21.61 32.47 21.61 52.18s-7.68 38.24-21.61 52.18c-13.94 13.94-32.47 21.61-52.18 21.61m0-142.05c-18.23 0-35.38 7.1-48.27 19.99S5.53 55.56 5.53 73.79s7.1 35.38 19.99 48.27 30.04 19.99 48.27 19.99 35.38-7.1 48.27-19.99 19.99-30.04 19.99-48.27-7.1-35.38-19.99-48.27S92.02 5.53 73.79 5.53" })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }